(function () {
  function variantIdFromDom() {
    var sel = document.querySelector("select[data-variant-select]");
    if (sel && sel.value) return sel.value;
    var inp = document.querySelector('#AddToCartForm input[name="id"]');
    return inp && inp.value ? inp.value : null;
  }

  function syncPanelsForRoot(root) {
    var heading = root.querySelector("[data-product-benefits-heading]");
    var panels = root.querySelectorAll("[data-variant-benefits-panel]");
    var id = variantIdFromDom();
    if (!id) return;

    var match = root.querySelector('[data-variant-benefits-panel="' + id + '"]');
    panels.forEach(function (p) {
      p.hidden = true;
    });

    if (match) {
      match.hidden = false;
      if (heading) heading.hidden = false;
      root.hidden = false;
    } else {
      if (heading) heading.hidden = true;
      root.hidden = true;
    }
  }

  if (!window.__productBenefitsChangeBound) {
    window.__productBenefitsChangeBound = true;
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches("select[data-variant-select]")) return;
      document.querySelectorAll("[data-product-benefits]").forEach(syncPanelsForRoot);
    });
  }

  document.querySelectorAll("[data-product-benefits]").forEach(syncPanelsForRoot);
})();
